var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterEarthIconLangSelector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18384_61795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49944 14.2508C11.2276 14.2508 14.2499 11.2286 14.2499 7.50042C14.2499 3.77227 11.2276 0.75 7.49944 0.75C3.77129 0.75 0.749023 3.77227 0.749023 7.50042C0.749023 11.2286 3.77129 14.2508 7.49944 14.2508Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26807 10.0983H3.08549C3.5675 10.0983 4.02977 9.90678 4.3706 9.56594C4.71143 9.22512 4.90291 8.76284 4.90291 8.28084V6.72305C4.90291 6.24104 5.09438 5.77877 5.43521 5.43794C5.77605 5.0971 6.23832 4.90563 6.72033 4.90563C7.20234 4.90563 7.66461 4.71415 8.00544 4.37331C8.34627 4.03248 8.53775 3.57022 8.53775 3.08821V0.824219",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2495 7.39588C13.7295 7.12608 13.1529 6.9837 12.5671 6.98047H10.355C9.87301 6.98047 9.41074 7.17194 9.0699 7.51278C8.72907 7.85361 8.5376 8.31588 8.5376 8.79789C8.5376 9.2799 8.72907 9.74217 9.0699 10.083C9.41074 10.4238 9.87301 10.6153 10.355 10.6153C10.6993 10.6153 11.0295 10.7521 11.273 10.9955C11.5164 11.2389 11.6532 11.5692 11.6532 11.9135V12.817",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18384_61795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterEarthIconLangSelector);
export default __webpack_public_path__ + "static/media/footer-earth-icon-lang-selector.fde372a89ea5db113724d1fb4d430982.svg";
export { ForwardRef as ReactComponent };